// GA4 event catalog for the web app. Always use these constants, never string literals.
// Names follow GA4 recommended events where one exists. Keep in sync with pm/analytics/events.md.
// The web app never sends `purchase`: revenue comes from the backend (Razorpay webhook).
export const EVENTS = Object.freeze({
  PAGE_VIEW: "page_view",
  UI_CLICK: "ui_click",
  LOGIN: "login",
  VIEW_ITEM: "view_item",
  ADD_TO_CART: "add_to_cart",
  VIEW_CART: "view_cart",
  BEGIN_CHECKOUT: "begin_checkout",
  ADD_PAYMENT_INFO: "add_payment_info",
  CHECKOUT_DROPOFF: "checkout_dropoff",
  PAYMENT_FAILED: "payment_failed",
  ORDER_CONFIRMATION_VIEW: "order_confirmation_view",
  CONSENT_CHANGED: "consent_changed",
  EXCEPTION: "exception",
});

export const MAX_EVENT_NAME = 40;
export const MAX_PARAMS = 25;
export const MAX_PARAM_NAME = 40;
export const MAX_PARAM_VALUE = 100;
